/**
 * src/hooks/useThreeGame.js
 */
import { useEffect, useRef } from 'react';
import ThreeGame from '../three/ThreeGame.js';

export function useThreeGame(containerRef, opts = {}) {
  const gameRef = useRef(null);
  const optsRef = useRef(opts);
  optsRef.current = opts;

  useEffect(() => {
    const container = containerRef.current;
    if (!container || gameRef.current) return;
    let cancelled = false;

    const game = new ThreeGame(container, {
      onHud: (data) => optsRef.current.onHud?.(data),
      onPlayEvent: (data) => optsRef.current.onPlayEvent?.(data),
      onProgress: (data) => {
        if (!cancelled) optsRef.current.onProgress?.(data);
      },
      onReady: () => {
        if (!cancelled) optsRef.current.onReady?.(game);
      },
    });
    gameRef.current = game;
    game.create();

    return () => {
      cancelled = true;
      game.destroy();
      gameRef.current = null;
    };
  }, [containerRef]);

  return gameRef;
}

export default useThreeGame;
